import { useTypedSelector } from '../store';
import { selectSelectedLanguage } from '../store/userData/selectors';
import { translate } from '../utils/translation';
export type TType = (key: string, returnKey?: boolean) => string;
export default function useTranslation() {
  const selectedLang = useTypedSelector(selectSelectedLanguage);
  return (key, returnKey = true) => translate(key, selectedLang, returnKey);
}
